const {
  REACT_APP_ENVIRONMENT: ENVIRONMENT,
  REACT_APP_API_URL: API_URL,
  REACT_APP_API_URL_DEV: API_URL_DEV,
  REACT_APP_API_URL_TEST: API_URL_TEST,
} = process.env;

export const getApiRoute = () => {
  const env = localStorage.getItem(ENVIRONMENT);

  switch (env) {
    case "production":
      return API_URL;
    case "test":
      return API_URL_TEST;
    case "development":
    default:
      return API_URL_DEV;
  }
};
